import React, { useState, useEffect } from 'react';

interface Props {
  currentRefinement: number,
  nbPages: number,
  refine: (pageNumber: number) => void,
  scrollPage: () => void,
  clearBulkSelected?: () => void,
  maxPageLinksToShow?: number,
}

const SimplePagination: React.FC<Props> = ({
  currentRefinement,
  nbPages,
  refine,
  scrollPage,
  clearBulkSelected,
  maxPageLinksToShow = 9,
}) => {
  const [pageNumbers, setPageNumbers] = useState<Array<number>>([]);

  useEffect(() => {
    const tempPages: number[] = [];

    if (currentRefinement - 4 > 0) {
      // eslint-disable-next-line no-plusplus
      for (let i = currentRefinement - 4; i < currentRefinement; i++) {
        tempPages.push(i);
      }
    } else {
      // eslint-disable-next-line no-plusplus
      for (let i = currentRefinement - 1; i > 0; i--) {
        tempPages.unshift(i);
      }
    }

    tempPages.push(currentRefinement);

    if (currentRefinement + 4 >= nbPages) {
      // eslint-disable-next-line no-plusplus
      for (let i = currentRefinement + 1; i <= nbPages; i++) {
        tempPages.push(i);
      }
    } else {
      const max = nbPages > maxPageLinksToShow ? maxPageLinksToShow : nbPages;
      // eslint-disable-next-line no-plusplus
      for (let i = currentRefinement + 1; i <= max; i++) {
        tempPages.push(i);
      }
    }

    setPageNumbers(tempPages);
  }, [currentRefinement, nbPages, setPageNumbers]);

  if (nbPages <= 1) {
    return <></>;
  }

  // @ts-ignore
  return (
    <div className="ais-Pagination">
      <ul className="ais-Pagination-list d-flex list-unstyled">
        <li className={`ais-Pagination-item--firstPage${currentRefinement === 1 ? ' ais-Pagination-item--disabled' : ''}`}>
          <button
            type="button"
            className="border-0 bg-transparent ais-Pagination-link"
            aria-label="Scroll to first page."
            /* @ts-ignore */
            disabled={currentRefinement === 1}
            onClick={(event) => {
              if (currentRefinement > 1) {
                refine(1);
                if (clearBulkSelected) {
                  clearBulkSelected();
                }
                scrollPage();
              }
            }}
          >
            ‹‹
          </button>
        </li>
        <li className={`ais-Pagination-item ais-Pagination-item--previousPage${currentRefinement === 1 ? ' ais-Pagination-item--disabled' : ''}`}>
          <button
            type="button"
            className="border-0 bg-transparent ais-Pagination-link"
            aria-label="Previous."
            /* @ts-ignore */
            disabled={currentRefinement === 1}
            onClick={(event) => {
              if (currentRefinement > 1) {
                refine(currentRefinement - 1);
                if (clearBulkSelected) {
                  clearBulkSelected();
                }
                scrollPage();
              }
            }}
          >
            ‹
          </button>
        </li>
        {pageNumbers.map((page) => {
          return (
            <li
              key={page}
              className={`ais-Pagination-item ais-Pagination-item--page${currentRefinement === page ? ' ais-Pagination-item--selected' : ''}`}
            >
              <button
                type="button"
                aria-label={`Go to page ${page}.`}
                className={`border-0 bg-transparent ais-Pagination-link${currentRefinement === page ? ' ais-Pagination-link--selected' : ''}`}
                onClick={(event) => {
                  refine(page);
                  if (clearBulkSelected) {
                    clearBulkSelected();
                  }
                  scrollPage();
                }}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li className={`ais-Pagination-item ais-Pagination-item--nextPage${currentRefinement === nbPages ? ' ais-Pagination-item--disabled' : ''}`}>
          <button
            type="button"
            className="border-0 bg-transparent ais-Pagination-link"
            aria-label="Next."
            /* @ts-ignore */
            disabled={currentRefinement === nbPages}
            onClick={(event) => {
              if (currentRefinement < nbPages) {
                refine(currentRefinement + 1);
                if (clearBulkSelected) {
                  clearBulkSelected();
                }
                scrollPage();
              }
            }}
          >
            ›
          </button>
        </li>
      </ul>
    </div>
  );
};

export default SimplePagination;
